module.exports = __webpack_public_path__ + "img/ss2.ecf9ce61.jpg";